import Admin from "./admin/Admin";
import EvaluationType from "./admin/EvaluationType";
import MetricByFactor from "./admin/MetricByFactor";
import PeriodoEvaluacion from "./admin/PeriodoEvaluacion";
import Factor from "./admin/Factor";
import FactorTemplate from "./admin/FactorTemplate";
import Periodicity from "./admin/Periodicity";
import PlanAccion from "../evaluacion_desempenio/admin/PlanAccion";
import CategoriaDesempenio from "../evaluacion_desempenio/admin/CategoriaDesempenio";
import CompetenciesTemplate from "./admin/CompetenciesTemplate";
import MetricaCompetencia from "../evaluacion_desempenio/admin/MetricaCompetencia";
import PesoCompetencia from "../evaluacion_desempenio/admin/PesoCompetencia";
import FactorQuestions from "./admin/FactorQuestion";
import CompetencyQuestions from "./admin/CompetencyQuestions";
import EmployeeMonitor from "./EmployeeMonitor";
import EvaluationMonitor from "./EvaluationMonitor";
import EvalFormCompetency from "../evaluacion_desempenio/EvalFormCompetency";
import EvalFormQuestions from "../evaluacion_desempenio/EvalFormQuestions";
import Overview from "./Overview";
import EvalFormQuestionsFactors from "../evaluacion_desempenio/EvalFormQuestionFactors";
import DashboardJefe from "./DashboardJefe";
import FactorName from "./admin/FactorName";
import EvaluationAccepted from "./EvaluationAccepted";
import DashboardResponsable from "./PowerBi/DashboardResponsable";
import EvaluatorCriteria from "./admin/EvaluatorCriteria";
import CollaboratorsToEvaluate from "./admin/CollaboratorsToEvaluate";
import EvaluationNotAccepted from "./EvaluationNotAccepted";
import PlanSeguimiento from "./PlanSeguimiento";
import Level from "./admin/Level";
import ObjectiveCompetencyPillar from "./admin/ObjectiveCompetencyPillar";
import ObjectiveValuePillar from "./admin/ObjectiveValuePillar";
import StrategicPillar from "./admin/StrategicPillar";
import ConfSmart from "./admin/ConfSmart";
import LevelEmployee from "./admin/LevelEmployee";
import FormType from "./admin/FormType";
import EmployeeObjectives from "./EmployeeObjectives";
import ObjectiveChangeHistory from "./ObjectiveChangeHistory";
import ObjectiveMetric from "./admin/ObjectiveMetric";
import ObjectiveCompetencyQuestion from "./admin/ObjectiveCompetencyQuestion";
import ObjectiveValueQuestion from "./admin/ObjectiveValueQuestion";
import ObjectivesEvaluationSummary from "./ObjectivesEvaluationSummary";
import DashboardJefeObjetivos from "./DashboardJefeObjetivos";

const EvaluacionDesempenioRouter = [
  {
    type: "private",
    path: "/evaluacion-desempenio/admin",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: Admin,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/tipo-evaluacion",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: EvaluationType,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/periodoEvaluacion",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: PeriodoEvaluacion,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/planAccion",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: PlanAccion,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/factor",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: Factor,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/nombre-factor",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: FactorName,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/niveles",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: Level,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/niveles-empleados",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: LevelEmployee,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/objetivos-competencias",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: ObjectiveCompetencyPillar,
    exact: true,
  },
   {
    type: "private",
    path: "/evaluacion-desempenio/admin/objetivos-competencias-preguntas/:idObjetivoCompetencia/:idConfiguracion",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: ObjectiveCompetencyQuestion,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/objetivos-valores",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: ObjectiveValuePillar,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/objetivos-valores-preguntas/:idObjetivoValor/:idConfiguracion",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: ObjectiveValueQuestion,
    exact: true,
  },

  {
    type: "private",
    path: "/evaluacion-desempenio/admin/pilar-estrategico",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: StrategicPillar,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/objetivos-metricas",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: ObjectiveMetric,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/conf-smart",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: ConfSmart,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/tipo-formulario",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: FormType,
    exact: true,
  },
  {
    type: "private",
    path: "/pesos-factor/:id",
    roles: ["administrador", "Responsable_Evaluacion", "jefe"],
    component: Factor,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/plantillas-por-periodo",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: FactorTemplate,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/preguntas-por-factor/:idPlantilla/:idPeriodicidad",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: FactorQuestions,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/periodicidad-de-aplicaciones-de-evaluaciones",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: Periodicity,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/métrica-por-factor",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: MetricByFactor,
    exact: true,
  },
  {
    path: "/evaluacion-desempenio/admin/categoriaDesempenio",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: CategoriaDesempenio,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/metricaCompetencia",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: MetricaCompetencia,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/preguntas-por-competencia",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: CompetenciesTemplate,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/pesoCompetencia",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: PesoCompetencia,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/admin/preguntas-por-competencia/:idPlantilla/:idPeriodicidad",
    roles: ["administrador", "Responsable_Evaluacion"],
    component: CompetencyQuestions,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/monitor-de-colaboradores",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Evaluacion",
      "alta_direccion",
    ],
    component: EmployeeMonitor,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/monitor-de-evaluación/:idColab/:nombreColab/:idFuncion/:nombreFuncion/:idDep/:nombreDep/:idEmpresa/:idClasifi",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Evaluacion",
      "alta_direccion",
    ],
    component: EvaluationMonitor,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluaciones/:id/:type/",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "Responsable_Evaluacion",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: EvaluationMonitor,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/formulario-evaluacion-competencia/:idFactor/:idCompetencia/:idEmpresa",
    roles: [
      "administrador",
      "Responsable_Evaluacion",
      "jefe",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: EvalFormCompetency,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/formulario-autoevaluacion/:idFactor/:idCompetencia/:idEmpresa/:jefe",
    roles: [
      "administrador",
      "Responsable_Evaluacion",
      "jefe",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: EvalFormCompetency,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-del-desempenio/autoevaluacion/:oType/:idColab/:type/:evaluationType/:idFactor/:idCompetencia",
    roles: [
      "administrador",
      "Responsable_Evaluacion",
      "alta_direccion",
      "empleado",
      "jefe",
      "Responsable_Headcount",
    ],
    component: EvalFormCompetency,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-del-desempenio/:idColab/:type/:evaluationType/:idFactor/:idCompetencia",
    roles: [
      "administrador",
      "Responsable_Evaluacion",
      "alta_direccion",
      "empleado",
      "jefe",
      "Responsable_Headcount",
    ],
    component: EvalFormCompetency,
    exact: true,
  },
  {
    type: "private",
    path: "/plan-de-seguimiento/:idPeriodicidad/:idFactor/:idCompetencia/:idEvaluado",
    roles: [
      "administrador",
      "Responsable_Evaluacion",
      "alta_direccion",
      "empleado",
      "jefe",
      "Responsable_Headcount",
    ],
    component: PlanSeguimiento,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/formulario-preguntas-competencias/:id/:periodicidad",
    roles: [
      "administrador",
      "Responsable_Evaluacion",
      "jefe",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: EvalFormQuestions,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/preguntas-por-competencias/:idColab/:type/:evaluationType/:id/:periodicidad",
    roles: [
      "administrador",
      "Responsable_Evaluacion",
      "alta_direccion",
      "empleado",
      "jefe",
      "Responsable_Headcount",
    ],
    component: EvalFormQuestions,
    exact: true,
  },
  {
    type: "private",
    path: "/resumen-general-de-evaluaciones/:idColab/:nombreColab/:idFuncion/:nombreFuncion/:idDep/:nombreDep/:idEvaluation/:idEmpresa",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Evaluacion",
      "alta_direccion",
      "empleado"
    ],
    component: Overview,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/formulario-preguntas-factor/:id/:periodicidad/:idFuncion",
    roles: [
      "administrador",
      "jefe",
      "Responsable_Evaluacion",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: EvalFormQuestionsFactors,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/preguntas-por-factor/:idColab/:type/:evaluationType/:id/:periodicidad/:idFuncion",
    roles: [
      "administrador",
      "Responsable_Evaluacion",
      "alta_direccion",
      "empleado",
      "jefe",
      "Responsable_Headcount",
    ],
    component: EvalFormQuestionsFactors,
    exact: true,
  },
  {
    type: "private",
    // path: "/evaluacion-desempenio/dashboard-jefe",
    path: "/evaluacion-desempenio/indicador-evaluaciones-de-desempeño",
    roles: ["jefe", "alta_direccion", "administrador"],
    component: DashboardJefe,
    exact: true,
  },
   {
    type: "private",
    path: "/evaluacion-desempenio/indicador-evaluaciones-de-desempeño-por-objetivos",
    roles: ["jefe", "alta_direccion", "administrador"],
    component: DashboardJefeObjetivos,
    exact: true,
  },
  {
    path: "/aceptacion-evaluacion-desempenio/:idEncabezado/:token",
    component: EvaluationAccepted,
    exact: true,
  },
  {
    path: "/no-aceptacion-evaluacion-desempenio/:idEncabezado/:token",
    component: EvaluationNotAccepted,
    exact: true,
  },
  {
    type: "private",
    // path: "/evaluacion-desempenio/dashboard-responsable",
    path: "/evaluacion-desempenio/tablero-evaluaciones-de-desempeño",
    roles: [
      "administrador",
      "Responsable_Evaluacion",
      "alta_direccion",
      "jefe",
    ],
    component: DashboardResponsable,
    exact: true,
  },

  {
    type: "private",
    path: "/evaluacion-desempenio/formulario-por-objetivos/:idEvaluacion/:idConfiguracion/:idEvaluacionGeneral",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "Responsable_Evaluacion",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: EmployeeObjectives,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/resumen-evaluacion-objetivos/:idEvaluacion/:idConfiguracion/:idEvaluacionGeneral",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "Responsable_Evaluacion",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: ObjectivesEvaluationSummary,
    exact: true,
  },
  {
    type: "private",
    path: "/evaluacion-desempenio/formulario-por-objetivos/historial/:idEvaluacion",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "Responsable_Evaluacion",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: ObjectiveChangeHistory,
    exact: true,
  },
  // {
  //   type: "private",
  //   path: "/evaluacion-desempenio/admin/criterios-evaluador",
  //   roles: ["administrador", "Responsable_Evaluacion"],
  //   component: EvaluatorCriteria,
  //   exact: true,
  // },
  // {
  //   type: "private",
  //   path: "/evaluacion-desempenio/admin/seleccion-colaboradores-evaluar",
  //   roles: ["administrador", "Responsable_Evaluacion"],
  //   component: CollaboratorsToEvaluate,
  //   exact: true,
  // },
];

export default EvaluacionDesempenioRouter;
